var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReuse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_80_1",
    "data-name": "Component 80 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35.008,
    height: 43.877,
    viewBox: "0 0 35.008 43.877",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.048,
    y1: 0.489,
    x2: 0.673,
    y2: 0.097,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3787c9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b2defa"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_8350",
    "data-name": "Path 8350",
    d: "M30.942,12.777A10.639,10.639,0,0,1,21.76,18,10.547,10.547,0,0,1,11.141,7.56h3.637L7.387,0,0,7.556H3.752a17.887,17.887,0,0,0,18.01,17.7,18.081,18.081,0,0,0,14.427-7.118Z",
    transform: "translate(25.261) rotate(90)",
    fill: "url(#linear-gradient)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8351",
    "data-name": "Path 8351",
    d: "M5.246,12.484a10.644,10.644,0,0,1,19.8,5.217H21.411L28.8,25.261,36.189,17.7H32.437A17.886,17.886,0,0,0,14.427,0,18.081,18.081,0,0,0,0,7.118Z",
    transform: "translate(35.008 7.688) rotate(90)",
    fill: "url(#linear-gradient)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReuse);
export default __webpack_public_path__ + "static/media/reuse.2e81fe658a84e0a4e604cfdfef71991e.svg";
export { ForwardRef as ReactComponent };